import Button from "../Button/Button";
import Delegate from "../../Delegate";
import './FileUpload.css';

export default class FileUpload extends Button {

	_input: HTMLInputElement;
	_Accept: string;
	EvFileChanged: Delegate;


	constructor(settings: object)
	{
		super(settings);
	}

	_initFields(settings: object)
	{
		this.EvFileChanged = new Delegate();
		this._Accept = null;
		super._initFields(settings);
	}

	_render()
	{
		super._render('div');
		this.addClass('app-button--file');
		this._input = FileUpload.createFileInputNode(this._Accept, (res: any) => this.EvFileChanged.fire(this, res));
		this._root.appendChild(this._input);
	}

	setValue(value: any)
	{
		this._input.value = value;
	}

	getValue()
	{
		return this.getFile();
	}


	getFile()
	{
		return this._input.files[0];
	}

	static createFileInputNode(accept: string, callbackChange: Function)
	{
		let node = document.createElement("input");
		node.setAttribute("type", "file");
		node.className = "file-input";

		if (accept)
			node.setAttribute("accept", accept);

		node.addEventListener("change", () =>
		{
			let file = node.files[0];
			if (file)
			{
				let reader = new FileReader();
				reader.onload = (ee) => callbackChange({Result: (<any>ee.target).result, File: file});
				if (file.type.match('image.*'))
					reader.readAsDataURL(file);
				else
					reader.readAsText(file);
			}
		});
		return node;
	}
};